enum ProductTempSettingsTypeEnum {
  dishes = 'dishes',
  service = 'service',
  shipping = 'shipping',
}

export default ProductTempSettingsTypeEnum;
